function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpcominggrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10532",
    transform: "translate(-564 -337)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 6015",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(564 337)",
    style: {
      fill: "#d6f6ff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 6379"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41168",
    d: "M-1126.942 758.593c3.014 0 6.028.023 9.041-.012a1.73 1.73 0 0 1 1.8 1.808c-.03 3.1-.008 6.194-.017 9.29 0 .256.066.324.323.332a6.81 6.81 0 0 1 6.427 5.667 6.836 6.836 0 0 1-5.6 7.907 6.844 6.844 0 0 1-6.881-3.047.552.552 0 0 0-.544-.293c-4.51.009-9.02-.013-13.53.02a1.755 1.755 0 0 1-1.876-1.865c.021-6.006.01-12.013.01-18.02a1.651 1.651 0 0 1 1.246-1.749 2.225 2.225 0 0 1 .558-.038z",
    transform: "translate(1715.556 -406.101)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41169",
    d: "M-1123.854 840.727c0-2.213 0-4.427-.005-6.64 0-.27.047-.373.351-.37 1.683.017 3.367.012 5.05 0 .228 0 .3.052.3.292-.015.81-.008 1.621-.005 2.431 0 .618.4.864.952.589.939-.465 1.879-.931 2.813-1.407a.443.443 0 0 1 .458 0c.923.473 1.854.933 2.783 1.4.594.3.974.059.975-.606 0-.8.005-1.6 0-2.4 0-.2.03-.294.266-.293q2.587.014 5.174 0c.22 0 .284.069.283.285q-.012 2.353 0 4.707c0 .216-.08.27-.28.311a6.828 6.828 0 0 0-5.37 5.7 6.56 6.56 0 0 0 .24 2.954c.076.239.066.315-.217.315q-6.577-.012-13.155-.006c-.458 0-.608-.153-.608-.622q-.006-3.32-.005-6.64z",
    transform: "translate(1702.78 -474.976)",
    style: {
      fill: "#00a6c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41170",
    d: "M-934.635 914.916a5.706 5.706 0 0 1-5.669 5.706 5.726 5.726 0 0 1-5.726-5.657 5.712 5.712 0 0 1 5.694-5.748 5.691 5.691 0 0 1 5.701 5.699z",
    transform: "translate(1539.77 -544.184)",
    style: {
      fill: "#faf871"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41171",
    d: "M-1036.2 779.327c-.833-.416-1.616-.795-2.386-1.2a.919.919 0 0 0-.94 0c-.706.373-1.429.713-2.137 1.081-.211.109-.254.073-.253-.157q.01-3.257 0-6.513c0-.214.058-.284.28-.283 1.724.008 3.449 0 5.173 0 .132 0 .268-.033.267.188-.004 2.282-.004 4.557-.004 6.884z",
    transform: "translate(1627.665 -418.638)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41172",
    d: "M-956.946 776.244c-.861 0-1.723-.008-2.584.005-.22 0-.277-.061-.275-.278q.016-1.712 0-3.425c0-.222.041-.3.285-.3 1.608.012 3.217.005 4.826.007.43 0 .6.171.606.607 0 1.048 0 2.1.006 3.144 0 .194-.061.245-.249.243-.869-.008-1.743-.003-2.615-.003z",
    transform: "translate(1552.396 -418.627)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41173",
    d: "M-1121.022 776.27c-.862 0-1.724-.006-2.585 0-.2 0-.263-.055-.261-.26.01-1.059 0-2.118.006-3.177 0-.383.17-.557.547-.557 1.64 0 3.281 0 4.921-.005.181 0 .226.059.225.231q-.01 1.775 0 3.551c0 .191-.075.218-.238.216-.871-.002-1.743.001-2.615.001z",
    transform: "translate(1702.787 -418.654)",
    style: {
      fill: "#84e681"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41174",
    d: "M-1038.889 965h-2.18c-.408 0-.651-.205-.661-.542a.589.589 0 0 1 .657-.589q2.18-.005 4.36 0c.412 0 .676.229.68.571s-.263.56-.677.561l-2.179-.001z",
    transform: "translate(1627.495 -594.276)",
    style: {
      fill: "#283045"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 41175",
    d: "M-884.377 929.574v-1.744a.573.573 0 0 1 .563-.642.578.578 0 0 1 .567.643c0 1.028.005 2.056 0 3.083a.512.512 0 0 0 .169.407c.461.449.915.906 1.367 1.363a.606.606 0 0 1 .078.882.586.586 0 0 1-.878-.071c-.546-.541-1.084-1.089-1.633-1.627a.747.747 0 0 1-.236-.583c.009-.569.003-1.14.003-1.711z",
    transform: "translate(1483.256 -560.656)",
    style: {
      fill: "#283045"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 8553",
    width: 56,
    height: 56,
    rx: 28,
    transform: "translate(564 337)",
    style: {
      mixBlendMode: "saturation",
      isolation: "isolate"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcominggrey);
export default __webpack_public_path__ + "static/media/upcominggrey.069d500b92fc4891b7820a0ab64d7d77.svg";
export { ForwardRef as ReactComponent };